// extracted by mini-css-extract-plugin
export default {"header-container":"styles_header-container__w0Vcc","main-container":"styles_main-container__12IIk","subheader-container":"styles_subheader-container__GkxjR"};